import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title: string
  subtitle: string
}

export const RouteItem = ({ title, subtitle }: Props) => {
  return (
    <div className={s.item}>
      <div className={clsx(s.time, 'medium-14')}>{title}</div>
      <div className={clsx(s.direction, 'regular-12')}>{subtitle}</div>
    </div>
  )
}
